export default "__VITE_ASSET__CjR4OuFL__"